import React, { useState } from "react";
import BaseBage from "../BasePage";
import {
  getPrecipitation
} from "../../api/FlaskAPI";
import precLegend from "../../assets/images/precipitation_legend.png";
import { useSelector } from "react-redux";
import NavPageSelector from "../../components/NavPageSelector";
import CoordinatesInput from "../../components/CoordinatesInput";
import Map from "../Masking/Map";
import SignInComponent from "../../components/Sign/SignComponent";
import { toast } from "react-toastify";
import MonitoringDialog from "../Masking/MonitoringDialog";
import { useParams } from "react-router-dom";

export default function Precipitation() {
  const { type, index } = useParams();
  const [open, setOpen] = useState(false);
  const areas = useSelector((state) => state.mapState.areas);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <BaseBage
        key={index}
        dataKey={index}
        monitoringKey={index}
        endpoint={getPrecipitation}
        route={index}
        legendImg={{ src: precLegend, style: "prec-legend-img" }}
      />
      {/* <div className="monitoring-container">
        <div className="map-wrapper">
          <NavPageSelector route={"masking"} />
          <div className="sign-up-container-base">
            <SignInComponent
              menuIconColor="black"
              backgroundColor="white"
              MT="0em"
              ML="0em"
              classN="modalcontainer-base"
            />
          </div>
          <CoordinatesInput disableFileUpload={false} />

          <Map />

          {/* side modal
          <div className="submit-compare-buttons-container">
            <button
              className="submit-compare-buttons"
              onClick={() => {
                if (!areas || !areas[0] || !areas[0].coordinates) {
                  toast.error(
                    "Please select the polygon you want to be predicted"
                  );
                } else {
                  handleOpen();
                }
              }}
            >
              Monitoring
            </button>
            <MonitoringDialog
              mainIndex="precipitation"
              open={open}
              handleClose={handleClose}
            />
          </div>
        </div>
      </div> */}
    </>
  );
}
